/**
 * 应用信息 API
 * 获取当前应用的公开信息（名称、Logo、状态等）
 * 此接口无需认证，用于登录页、应用不可用页面等
 */
import { request } from '@umijs/max';

/** 应用信息响应 */
export interface AppProfile {
  id: string;
  name: string;
  logo: string;
  status: string;
  configs?: Record<string, string>;
}

interface APIResponse<T> {
  status: 'ok' | 'error';
  data?: T;
  error?: { code: string; message: string };
}

/** 获取当前应用公开信息 */
export async function fetchAppProfile(): Promise<AppProfile | null> {
  try {
    const res = await request<APIResponse<AppProfile>>(
      '/api/v1/saas/public/app/profile',
      { method: 'GET' },
    );
    return res?.data ?? null;
  } catch {
    return null;
  }
}
